import { render, staticRenderFns } from "./midi-head-mask.vue?vue&type=template&id=fe0f7ca4&scoped=true"
import script from "./midi-head-mask.vue?vue&type=script&lang=js"
export * from "./midi-head-mask.vue?vue&type=script&lang=js"
import style0 from "./midi-head-mask.vue?vue&type=style&index=0&id=fe0f7ca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0f7ca4",
  null
  
)

export default component.exports